import "./Hero.css";
import { motion } from "framer-motion";
import WaitlistForm from "../WaitlistForm/WaitlistForm";

function Hero() {
  const titleItems = [
    "Her ağlamayı anlayan",
    "Her anı koruyan",
    "Akıllı yardımcınız",
  ];

  const earlyAccessBenefits = [
    "İlk davet grubunda yer alın",
    "Gelişmeleri önce siz öğrenin",
    "Beta geri bildirim sürecine katılın",
  ];

  return (
    <section className="hero">
      <div className="hero-bg"></div>
      <div className="hero-noise"></div>

      <div className="container hero-container">
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 35 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: .8 }}
        >
          <motion.div
            className="hero-eyebrow-row"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: .2 }}
          >
            <span className="hero-badge">Yeni Nesil AI Destekli Bebek Asistanı</span>
          </motion.div>

          <motion.h1
            className="hero-title-list"
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: .3 }}
          >
            {titleItems.map((item) => (
              <span key={item}>{item}</span>
            ))}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: .45 }}
          >
            Bybebek; ses, görüntü, oda koşulları ve uyku takibini bir araya
            getirerek bebeğinizin ihtiyaçlarını daha anlaşılır hale getirir.
            Önemli değişikliklerde sizi anlık bildirimlerle haberdar eder.
          </motion.p>

          <motion.div
            className="hero-benefits"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: .55 }}
          >
            {earlyAccessBenefits.map((benefit) => (
              <span key={benefit}>{benefit}</span>
            ))}
          </motion.div>
        </motion.div>

        <motion.div
          className="hero-right"
          initial={{ opacity: 0, scale: .96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: .9 }}
        >
          <div className="hero-form-card" id="waitlist">
            <h2>
              Bybebek'i ilk deneyimleyenlerden
              <br />
              biri olun.
            </h2>

            <p>
              Başvuru bilgilerinizi bırakın; ürün gelişmeleri, lansman duyuruları
              ve erken erişim davetleri için sizinle e-posta üzerinden iletişime
              geçelim.
            </p>

            <WaitlistForm variant="hero" buttonLabel="Erken Erişim Başvurusu Yap" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
